import { Modal } from 'antd';
import Loader from 'components/Loader';

const DownloadingPDFModalIntegration = () => {
  return (
    <Modal
      className="simple-info-modal download-pdf-modal"
      centered
      visible
      closable={false}
      zIndex={1001}
      maskClosable={false}>
      <h3 className="title">Generating PDF</h3>
      <div className="divider" />

      <p className="body">
        <span>This might take a while</span>
      </p>

      <div className="spinner">
        <Loader />
      </div>
    </Modal>
  );
};

export default DownloadingPDFModalIntegration;
